<template>
  <div>
    <app-drawer
      ref="appDrawer"
      :isBusy="isLoading"
      @close="closeDrawer"
      title="Add Parts for the Estimate Report"
    >
      <div class="el-drawer__content" v-loading="isLoading">
        <div class="el-drawer__content-wrapper">
          <el-form>
            <el-form-item label="Select spare parts">
              <el-select
                v-model="formModel.parts"
                multiple
                placeholder="Select"
                filterable
                @change="setSelectedPart"
                @remove-tag="tagRemoved"
              >
                <el-option
                  v-for="item in parts"
                  :key="item.id"
                  :label="item.part_no"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-table :data="selectedParts">
              <el-table-column width="60px">
                <template slot-scope="scope">
                  <el-button
                    type="danger"
                    icon="el-icon-delete"
                    title="Delete"
                    circle
                    size="small"
                    @click="removePart(scope.row)"
                  ></el-button>
                </template>
              </el-table-column>
              <el-table-column width="150" label="Part No." prop="part_no">
              </el-table-column>
              <el-table-column label="Part Description" prop="description">
              </el-table-column>
              <el-table-column label="Quantity" prop="quantity">
                <template slot-scope="scope">
                  <el-input-number
                    v-model.number="scope.row.quantity"
                    :controls="false"
                  ></el-input-number>
                </template>
              </el-table-column>
              <el-table-column label="Amount" prop="amount">
                <template slot-scope="scope">
                  <el-input-number
                    v-model.number="scope.row.amount"
                    :controls="false"
                  ></el-input-number>
                </template>
              </el-table-column>
            </el-table>
            <div class="masonry mt-2">
              <masonry :cols="2" :gutter="15">
                <div
                  v-for="(file, index) in formModel.images"
                  :key="`img-${index}`"
                  style="position: relative"
                >
                  <a
                    href="#"
                    class="text-danger"
                    style="position: absolute; background: #fff; height: 20px; width: 20px"
                    @click="deleteFile(file)"
                  >
                    <i class="el-icon-close"></i>
                  </a>
                  <img :src="getImageSrc(file)" alt="img" />
                </div>
              </masonry>
            </div>
          </el-form>
        </div>
        <div class="el-drawer__footer">
          <el-button
            size="small"
            type="primary"
            @click="save"
            :disabled="isLoading"
            class="mr-1"
            >Save</el-button
          >
          <app-uploader
            url="/api/v1/inventory/fileupload/"
            :params="{ q: 'uld' }"
            @uploadSuccess="handleUploadSuccess(arguments)"
            accept="image/*"
            :multiple="false"
            :fileList="formModel.images"
          ></app-uploader>
        </div>
      </div>
    </app-drawer>
  </div>
</template>

<script>
import Part from "@/models/Part";
import ULD from "@/models/ULD";
export default {
  name: "EstimateForm",
  data: () => ({
    isLoading: false,
    formModel: { parts: [], images: [] },
    parts: [],
    selectedParts: []
  }),
  computed: {
    uld() {
      return this.$store.getters["uld/info"];
    }
  },
  methods: {
    open() {
      this.$refs.appDrawer.open();
      this.isLoading = true;
      Part.getGlossary().then(list => {
        this.isLoading = false;
        this.parts = list;
      });

      if (this.uld.estimates) {
        let estimates = JSON.parse(this.uld.estimates);
        this.formModel.parts = [];
        this.selectedParts = [];
        for (let item of estimates) {
          this.formModel.parts.push(item.id);
          this.selectedParts.push({
            ...item
          });
        }
        ULD.get_uld_ber({ uldin_id: this.uld.id }).then(resp => {
          this.formModel.images = resp.data;
        });
      }
    },
    closeDrawer() {
      this.formModel.parts = [];
      this.selectedParts = [];
      this.$refs.appDrawer.close();
    },
    setSelectedPart() {
      if (this.formModel.parts.length > 0) {
        for (let i of this.formModel.parts) {
          let check = this.selectedParts.find(o => o.id == i);
          if (!check) {
            let item = this.parts.find(o => o.id == i);
            if (item)
              this.selectedParts.push({ ...item, quantity: 0, amount: 0 });
          }
        }
      }
    },
    tagRemoved(v) {
      this.selectedParts = this.selectedParts.filter(o => o.id != v);
    },
    save() {
      this.$confirm("Do you want to save this estimate information?")
        .then(() => {
          this.isLoading = true;
          let payload = {
            id: this.uld.id,
            estimates: JSON.stringify(this.selectedParts)
          };
          //   console.log(payload);
          ULD.update(payload).then(resp => {
            if (resp) {
              this.$store.dispatch("uld/setEstimates", payload.estimates);
              this.closeDrawer();
              this.$notify({
                message: "ULD Estimates saved",
                type: "success",
                position: "bottom-left"
              });
            }
            this.isLoading = false;
          });
        })
        .catch(() => {});
    },
    removePart(item) {
      if (item) {
        this.selectedParts = this.selectedParts.filter(o => o.id != item.id);
      }
    },
    deleteFile(file) {
      if (file.id) {
        ULD.delete_uld_ber({ id: file.id });
        this.formModel.images = this.formModel.images.filter(
          o => o.id != file.id
        );
      }
    },
    getImageSrc(file) {
      if ("_file" in file) return URL.createObjectURL(file._file.raw);
      else return "data:image/jpg;base64," + file.image;
    },
    handleUploadSuccess(resp) {
      let res = resp[0],
        file = resp[1];
      let s = file.name.split(".");
      s.pop();
      let filename = s.join("");

      let obj = {
        _file: file,
        name: filename,
        url: res.data.msg
      };
      ULD.put_uld_ber({ uld_id: this.uld.id, directory: obj.url }).then(
        resp => {
          obj.id = resp.data.id;
        }
      );
      this.formModel.images.push(obj);
    }
  }
};
</script>

<style lang="scss" scoped></style>
